<template>
    <date-picker
        class="vh-dropdown-calendar"
        mode="range"
        :masks="masks"
        v-model.range="dateRange"
        @drag="drag($event)"
        @dayclick="dayClick"
        @daymouseenter="dayMouseEnter"
        expanded>
    </date-picker>
</template>

<script>

import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';

export default
{
    components:
    {
        DatePicker
    },

    props:
    {
        attributes:
        {
            type: Array,
            default: () => {
                return [];
            },
        },

        range:
        {
            type: Object,
            default: () => {
                return {
                    start: '',
                    end: '',
                }
            }
        },

        onSelectRange: Function,
    },
    
    data()
    {
        return {
            masks:
            {
                weekdays: 'WWW',
            },

            // range:
            // {
            //     start: '',
            //     end: '',
            // }
        };
    },

    computed:
    {
        dateRange:
        {
            get()
            {
                return this.$parent.$parent.$parent.$parent.$data.range;
            },

            set (value)
            {
                this.$parent.$parent.$parent.$parent.$data.range = value;
            },
        }
    },

    methods:
    {
        drag(event)
        {
            this.$emit('onSelectRange', event);
        },

        dayClick()
        {
            // console.log('day clicked..');
        },

        dayMouseEnter()
        {
            console.log('day mouse entered...');
        },
    }
    
};
</script>
